import { addDays, endOfDay, isAfter, isBefore, lastDayOfMonth, startOfDay, startOfMonth } from "date-fns";
import { format } from "@/lib/time";

export function getStartOfDay(date: string | number | Date): Date {
  const type = typeof date;
  return startOfDay(new Date(type !== "string" ? date : date + "T00:00:00"));
}
export function getStartDayOfMonth(date: string | number | Date): Date {
  return startOfMonth(getStartOfDay(date));
}
export function getLastDayOfMonth(date: string | number | Date): Date {
  return lastDayOfMonth(getStartOfDay(date));
}
export function getLastDayOfPrevMonth(date: string | number | Date): Date {
  return endOfDay(addDays(getStartDayOfMonth(date), -1));
}
export function getStartDayOfNextMonth(date: string | number | Date): Date {
  return addDays(getLastDayOfMonth(date), 1);
}
export function isInCurrentMonth(targetDate: Date, sourceDate: Date): boolean {
  return (
    isAfter(targetDate, getLastDayOfPrevMonth(sourceDate)) && isBefore(targetDate, getStartDayOfNextMonth(sourceDate))
  );
}
export function getFormattedDate(date: string | number | Date): string {
  return format(getStartOfDay(date), "yyyy-MM-dd");
}
